export default __webpack_public_path__ + "static/media/Terms_of_Services_PT.96630918.pdf";